/* eslint-disable max-len */
import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { Params, RouterModule } from '@angular/router';
import { Product } from '@app/akita/api/products/models/product.model';
import { AkitaRouterQuery } from '@app/akita/router/state/router.query';
import { AkitaScreenQuery } from '@app/akita/screen/state/screen.query';
import { ScreenSizeInfoState } from '@app/akita/screen/state/screen.store';
import { GalleryComponent } from '@app/components/gallery/gallery.component';
import { FeaturedDescriptionCardComponent } from '@app/featured/components/featured-description-card/featured-description-card.component';
import { FeaturedDetailsCardComponent } from '@app/featured/components/featured-details-card/featured-details-card.component';
import { FeaturedDiscountBadgeComponent } from '@app/featured/components/featured-discount-badge/featured-discount-badge.component';
import { FeaturedHighlightsComponent } from '@app/featured/components/featured-highlights/featured-highlights.component';
import { FeaturedPurchaseInfoCardComponent } from '@app/featured/components/featured-purchase-info-card/featured-purchase-info-card.component';
import { FeaturedSpecsSelectorComponent } from '@app/featured/components/featured-specs-selector/featured-specs-selector.component';
import { HomeHighlightsComponent } from '@app/home/components/home-highlights/home-highlights.component';
import { ProductJsonLdComponent } from '@app/products/components/product-json-ld/product-json-ld.component';
import { ChevronDownIconComponent } from '@app/shared/components/icons/generated/chevron-down/chevron-down.component';
import { SpecUsbIconComponent } from '@app/shared/components/icons/generated/spec-usb/spec-usb.component';
import { UiSkeletonComponent } from '@app/shared/components/ui-skeleton/ui-skeleton.component';
import { TranslocoModule } from '@ngneat/transloco';
import { Observable, map } from 'rxjs';

@Component({
  selector: 'app-featured-listing-details-card',
  templateUrl: './featured-listing-details-card.template.html',
  styleUrls: ['./featured-listing-details-card.style.scss'],
  imports: [
    CommonModule,
    TranslocoModule,
    RouterModule,
    FlexLayoutModule,
    GalleryComponent,
    ProductJsonLdComponent,
    FeaturedDetailsCardComponent,
    FeaturedPurchaseInfoCardComponent,
    UiSkeletonComponent,
    HomeHighlightsComponent,
    FeaturedHighlightsComponent,
    FeaturedSpecsSelectorComponent,
    FeaturedDescriptionCardComponent,
    FeaturedDiscountBadgeComponent,
    ChevronDownIconComponent,
    SpecUsbIconComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeaturedListingDetailsCardComponent {
  @Input() public avatarId?: number | null;
  @Input() public product?: Product | null;
  @Input() public currency?: string | null;
  @Input() public galleryPictures?: Array<{
    src: string;
    thumb: string;
  }> | null;

  public readonly rtlMode: boolean;
  public readonly biggerThan$: Observable<ScreenSizeInfoState>;
  public isBrowser: boolean;
  public readonly testProductPage$: Observable<string | null>;

  public isDescriptionExpanded = false;

  constructor(
    private readonly akitaScreenQuery: AkitaScreenQuery,
    private readonly akitaRouterQuery: AkitaRouterQuery
  ) {
    this.biggerThan$ = this.akitaScreenQuery.selectBiggerThan();
    this.rtlMode = this.akitaRouterQuery.isRtlLanguage;
    this.isBrowser = this.akitaRouterQuery.isBrowser;

    this.testProductPage$ = this.akitaRouterQuery.selectParamsAndQueryParams().pipe(
      map((params: Params): string | null => {
        // testing page
        if (params.t) {
          return params.t;
        }
        return null;
      })
    );
  }
}
